import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import NeuroMessage from '../../components/NeuroMessage';
import {useNeuroMessages} from '../../components/MessageContext.jsx';
import {useAnswers} from '../../hooks/useAnswers';
import {useUser} from '../../hooks/useUser';
import {useGuideConfig} from '../../hooks/useGuideConfig';

const AnswersList = ({ className, filter, renderAnswer, linkToQuestion }) => {
  const { answers, answersWithPageInfo, parseAnswerValue } = useAnswers();
  const { uuid } = useUser();
  const { isMockMode } = useGuideConfig();
  const messageContext = useNeuroMessages();
  const cssBem = 'answersList';
  const classes = classnames(className, cssBem);
  const answersToFilter = filter || [
    'guideStartTime',
    'guideEndTime',
    'guideStarted',
  ];

  const filterHiddenAndNullAnswers = ({ appkey, view, value }) => {
    const hasValue = value !== null;
    const isHidden = view && view.attributes && view.attributes.hidden;
    const isSystemAppKey = answersToFilter.includes(appkey) || !view;
    return isMockMode ? true : (hasValue && !isHidden && !isSystemAppKey);
  };

  const renderAnswers = () => {
    const cssBEM = 'answer';
    var pageInfoAnswers = {};
    answersWithPageInfo.forEach(answer => pageInfoAnswers[answer.appkey] = {...answer, ...answer.answer});
    const extractedAnswers = linkToQuestion ? pageInfoAnswers : answers;


    const filteredAnswers = Object.entries(extractedAnswers)
      /* eslint-disable-next-line no-unused-vars */
      .filter(([key, answer]) => filterHiddenAndNullAnswers(answer));

    /* eslint-disable-next-line no-unused-vars */
    const sortedAnswers = filteredAnswers.sort(([_, a], [_2, b]) => {
      return new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime();
    });

    return sortedAnswers.map(([key, answer]) => {
      return renderAnswer ? (
        renderAnswer(key, answer)
      ) : (
        <div className={cssBEM} key={`${key}_${answer}`}>
          <h4 className={`${cssBEM}__key`}>
            <NeuroMessage
              id={
                messageContext.hasMessage(`details.${answer.appkey}`)
                  ? `details.${answer.appkey}`
                  : answer.appkey
              }
            />
          </h4>
          <div className={`${cssBEM}__container`}>
            <div className={`${cssBEM}__value`}>
              {parseAnswerValue({answer, useDetailsMessage: true})}
            </div>
            { linkToQuestion && answer?.pathKey && <a className={`${cssBEM}__edit`} href={`/guide/spa/${ uuid }/${ answer.pathKey }/${ answer.pageKey }`}><NeuroMessage id='editAnswer' /></a> }
          </div>
        </div>
      );
    });
  };

  return <div className={classes}>{renderAnswers()}</div>;
};

AnswersList.propTypes = {
  className: PropTypes.string,
  filter: PropTypes.array,
  renderAnswer: PropTypes.func,
  linkToQuestion: PropTypes.bool,
};

export default AnswersList;
